module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-26.9c41c059.png";